import { combineReducers } from 'redux'
import {
  GET_DATA_LIST_PRICE_BRISTORE
} from '../actions/bristoreAction'

const bristoreList = (state = {bool:false, data:[]}, action) => {
  switch (action.type) {
    case GET_DATA_LIST_PRICE_BRISTORE:
      return {bool:action.bool, data:action.val}
    default:
      return state
  }
}

const priceReducer = combineReducers({
  bristoreList,
})

export default priceReducer